import {Typography} from "../typography/Typography";
import {useAppTranslation} from "../app/appContext";
import {SafeRichTextRenderer} from "../common/richText/SafeRichTextRenderer";

export const LesserMatchContent = ({title, text, percentageMatch}) => {
    const t = useAppTranslation()
    return (
        <div>
            <Typography
                tag={"h2"}
                size={"xl"}
            >
                {title}
            </Typography>
            <Typography
                tag={"h3"}
                size={"lg"}
            >
                {Math.round(percentageMatch)}% {t('match', "match")}
            </Typography>
            <SafeRichTextRenderer text={text} />
        </div>
    )
}
